module.exports = __webpack_public_path__ + "img/2.c19045d3.png";